class Catalog {

  public static instance: Catalog | null = null;

  private path: string;
  private mChildren: any[]; // TODO: type this

  private constructor(path: string) {
    this.path = path;
    this.mChildren = [];
  }

  public static init(path: string): void {
    if (Catalog.instance == null) {
      Catalog.instance = new Catalog(path);
    }
  }

  public request(): Promise<string | void> {
    return fetch(this.path)
      .then((response: Response) => response.text())
      .then((text: string) => {
        //console.log(text);
        try
        {
            this.mChildren = JSON.parse(text);
            return new Promise<string>(
                (resolve, reject) => {
                  resolve("catalog is ready!");
                  reject("Error: Catalog request failed!");
                }
              );
        } catch (error: any) {
            console.error("Error parsing JSON:", error);
        }
      });
  }

  public findByID(id: number): any {
    for (let child of this.mChildren) {
      if (child.ID == id) {
        return child;
      }
    }
  }

  public children(): any[] {
    return Object.values(this.mChildren);
  }
}

export default Catalog;
